import { useEffect, useState } from 'react';
import { contentApi } from '../lib/api';
import { useI18n } from '../context/I18nContext';

const CACHE = {};   // { [lang]: content }
const PENDING = {}; // { [lang]: promise }

async function fetchOnce(lang) {
  if (CACHE[lang]) return CACHE[lang];
  if (!PENDING[lang]) PENDING[lang] = contentApi.getPublic(lang).catch(() => ({}));
  CACHE[lang] = await PENDING[lang];
  return CACHE[lang];
}

export function invalidateContentCache() {
  for (const k of Object.keys(CACHE)) delete CACHE[k];
  for (const k of Object.keys(PENDING)) delete PENDING[k];
}

export default function useContent() {
  const { lang } = useI18n();
  const [content, setContent] = useState(CACHE[lang] || {});

  useEffect(() => {
    let alive = true;
    fetchOnce(lang).then((data) => { if (alive) setContent(data); });
    return () => { alive = false; };
  }, [lang]);

  return content;
}
